const initialState = {
    userCountryCode: "",
    stateCode: "",
    allSelectedTNC:false,
    currencyCode:[]
};

const UserInfoReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_COUNTRY':{
            return  {
                ...state,
                userCountryCode:action.value
            }
        } 
        case 'SET_COUNTRY_STATES' : {
            return {
                ...state,
                countryStates : action.value
            }
        }
        case 'SET_COUNTRY_CURRENCY' : {
            return {
                ...state,
                currencyCode : action.value
            }
        }
        case 'SET_STATE' : {
            return {
                ...state,
                stateCode : action.value
            }
        }
        case 'SET_EVENT_TERM_CONDITION' : {
            return {
                ...state,
                eventTermsCondition : action.value
            }
        }
        case 'SET_TERM_CONDITION_ACCEPTED' : {	
            return {	
                ...state,	
                termsConditionAccepted : action.value	
            }	
        }
        case 'SET_EVENT_WALLET_APP' : {	
            return {	
                ...state,	
                eventMiniWallet : action.value	
            }	
        }
        default:
            return state;
    }

};

export default UserInfoReducer;
